import { render } from "./patientabout.vue?vue&type=template&id=54cd6a1c"
import script from "./patientabout.vue?vue&type=script&lang=js"
export * from "./patientabout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__